export default __webpack_public_path__ + "static/media/dedication-bg.c726d32e.svg";